const normalizeSearchValue = (value: unknown) =>
  String(value ?? '').toLowerCase().trim();

const fieldIncludes = (value: unknown, query: string) =>
  normalizeSearchValue(value).includes(query);

const compactValues = (values: unknown[]) =>
  values
    .map((value) => normalizeSearchValue(value))
    .filter((value) => Boolean(value));

const getAssignedCommunityDetails = (admin: any): any[] => {
  const rawCommunities = admin?._raw?.communityDetails;
  if (Array.isArray(rawCommunities)) return rawCommunities;

  const communityDetails = admin?.communityDetails;
  if (Array.isArray(communityDetails)) return communityDetails;

  const communities = admin?.communities;
  return Array.isArray(communities) ? communities : [];
};

const getCommunityId = (community: any) =>
  community?.communityId ||
  community?.id ||
  community?.uuid ||
  community?.flexoCommunityId;

const getCommunityLookupValues = (community: any) =>
  compactValues([
    getCommunityId(community),
    community?.communityName,
    community?.name,
    community?.communityExternalId,
    community?.externalId,
    community?.externalID,
    community?.external_id,
    community?.communityCode,
    community?.code,
  ]);

const getAssignedCommunitiesWithResolvedData = (
  admin: any,
  allCommunities: any[] = []
) => {
  const assignedCommunities = getAssignedCommunityDetails(admin);
  if (allCommunities.length === 0) return assignedCommunities;

  const communitiesByLookupValue = new Map<string, any>();
  allCommunities.forEach((community) => {
    getCommunityLookupValues(community).forEach((lookupValue) => {
      communitiesByLookupValue.set(lookupValue, community);
    });
  });

  return assignedCommunities.flatMap((community) => {
    const resolvedCommunities = getCommunityLookupValues(community)
      .map((lookupValue) => communitiesByLookupValue.get(lookupValue))
      .filter(Boolean);
    return [community, ...resolvedCommunities];
  });
};

const communityMatches = (community: any, query: string) =>
  [
    community?.communityName,
    community?.name,
    community?.communityExternalId,
    community?.externalId,
    community?.externalID,
    community?.external_id,
    community?.communityCode,
    community?.code,
    community?.communityId,
    community?.id,
    community?.uuid,
    community?.flexoCommunityId,
  ].some((value) => fieldIncludes(value, query));

export const adminUserMatchesSearch = (
  admin: any,
  searchText: string,
  allCommunities: any[] = []
) => {
  const query = normalizeSearchValue(searchText);
  if (!query) return true;

  const directMatch = [
    admin?.user,
    admin?.userId,
    admin?.clerkUserId,
    admin?.email,
    admin?.role,
    admin?.communities,
  ].some((value) => fieldIncludes(value, query));

  if (directMatch) return true;

  return getAssignedCommunitiesWithResolvedData(admin, allCommunities).some(
    (community) => communityMatches(community, query)
  );
};
